import { MoreVertical } from 'lucide-react';
import React from 'react';
import useStaticImage from '../../hooks/useStaticImage';

interface InspectionInfoCardProps {
  name: string;
  type: string;
  model: string;
  customerName: string;
  siteName: string;
  useBucket?: boolean;
  onPressed?: () => void;
}

const InspectionInfoCard: React.FC<InspectionInfoCardProps> = ({
  name,
  type,
  model,
  customerName,
  siteName,
  useBucket = false,
  onPressed,
}) => {
  const MachineImage = useStaticImage('images/machine_icon.png');
  const BucketImage = useStaticImage('images/bucket_icon.png');

  return (
    <div onClick={onPressed} className="p-2">
      <div className="flex cursor-pointer items-center space-x-6 bg-white p-2 hover:bg-brandLight/30">
        <img
          src={useBucket ? BucketImage : MachineImage}
          className="size-12 rounded-sm"
        />

        <div className="flex w-full justify-between">
          <div className="">
            <div className="truncate text-xl font-bold">{name}</div>
            <div className="mb-2 text-inkDisabled">
              {model} · {type}
            </div>
            <div className="mb-2 font-bold">
              {customerName} · {siteName}
            </div>
          </div>
          <MoreVertical
            className="size-6 text-inkMuted"
            onClick={(e) => {
              e.stopPropagation();
              console.log('More clicked');
            }}
          />
          {/* <div className="grow"></div> */}
        </div>
      </div>
    </div>
  );
};

export default InspectionInfoCard;
